import React from 'react'

type CareerIntroProps = {
  title: string
  subtitle?: string
  description?: string
  image: string
  className?: string
}

const CareerIntro: React.FC<CareerIntroProps> = ({
  title,
  subtitle,
  description,
  image,
  className = '',
}) => (
  <div className={`flex gap-5 max-w-[700px] ${className}`}>
    <img
      src={image}
      alt={title}
      className="w-[104px] h-[104px] min-w-[104px] rounded-full border border-gray-light object-cover shadow-subtle"
    />
    <div className="flex flex-col justify-center gap-1.5">
      <p className="text-lg font-semibold leading-5 text-brand">{title}</p>
      {subtitle && (
        <p className="text-body-sm font-normal text-gray-medium">{subtitle}</p>
      )}
      {description && (
        <p className="text-body font-normal text-gray-dark">{description}</p>
      )}
    </div>
  </div>
)

export default CareerIntro
